import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKodePelatihan = 'pelatihan/kode-pelatihan';
const getKodePelatihanAll = 'pelatihan/kode-pelatihan';
const postKodePelatihanUrl = 'pelatihan/kode-pelatihan';
const putKodePelatihan = 'pelatihan/kode-pelatihan/';
const deleteKodePelatihan = 'pelatihan/kode-pelatihan/';


class KodePelatihanService {
    getKodePelatihan(currentPage, pageSize, filter) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
        };
        
        return axios.get(
            API_URL + getKodePelatihan ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getKodePelatihanAktif(currentPage, pageSize, filter) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            status : "aktif"
        };
        
        return axios.get(
            API_URL + getKodePelatihan ,
        {
            params : data,
            headers: authHeader()
        });
    }
    
    getKodePelatihanAll() {
         return axios.get(
             API_URL + getKodePelatihanAll, {
                 headers: authHeader()
             });
     }

    postKodePelatihan(formData) {
        return axios
        .post(
            API_URL + postKodePelatihanUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKodePelatihan(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKodePelatihan + formData.idKodePelatihan, formData,
            { headers: authHeader() }
        );
    }

    deleteKodePelatihan(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKodePelatihan + formData.idKodePelatihan,
                { headers: authHeader() }
            );
    }

}

export default new KodePelatihanService();